import { setUserId, trackStructEvent } from '@snowplow/browser-tracker';
import { getPlatform } from '@/domains/shared/utils/native';

export function snowplowSetUser(userId: string | null) {
  setUserId(userId);
}

const EVENTS = {
  CONVERTED_LEAD: {
    category: 'conversion',
    action: 'converted_lead',
    label: 'CL',
  },
  REGISTERED_CUSTOMER: {
    category: 'conversion',
    action: 'registered_customer',
    label: 'RC',
  },
} as const;

type SnowplowEventName = keyof typeof EVENTS;

export function snowplowConversionEvent(eventName: SnowplowEventName) {
  const event = EVENTS[eventName];

  trackStructEvent({
    category: event.category,
    action: event.action,
    label: event.label,
    property: getPlatform(),
  });
}
